import { ItemType } from './api/ActivityWall';
import { MdChatBubbleOutline as PostIcon } from '@react-icons/all-files/md/MdChatBubbleOutline';
import { MdEdit as UpdateIcon } from '@react-icons/all-files/md/MdEdit';
import { TiFlash as FlashIcon } from '@react-icons/all-files/ti/TiFlash';
import { TiWarningOutline as DangerIcon } from '@react-icons/all-files/ti/TiWarningOutline';
import { FiUsers as GreetIcon } from '@react-icons/all-files/fi/FiUsers';
import { RiPushpinLine as PinnedIcon } from '@react-icons/all-files/ri/RiPushpinLine';
import { IconType } from '@react-icons/all-files';

interface WallEvent {
  icon: IconType;
  color: string;
  title: string;
}

const WallEvents: { [key in ItemType]: WallEvent } = {
  POST: {
    icon: PostIcon,
    title: 'Commentaire',
    color: '#2196F3FF',
  },
  UPDATE: {
    icon: UpdateIcon,
    title: 'Modification',
    color: '#ff5722',
  },
  FLASH: {
    icon: FlashIcon,
    title: 'Evénement',
    color: '#10cc52',
  },
  DANGER: {
    icon: DangerIcon,
    title: 'Incident',
    color: '#e91e63',
  },
  GREET: {
    icon: GreetIcon,
    title: 'Contact',
    color: '#303f9f',
  },
  PINNED: {
    icon: PinnedIcon,
    title: 'Epinglé',
    color: '#ff9800',
  },
};

export default WallEvents;
export { WallEvent };
